import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import adBannerGeneralBlockData from '../../../Models/Content/AdBannerGeneralBlockData';
import AdBannerMain from './AdBannerMain.js';

export default class AdBannerGeneralBlock extends EpiComponent<adBannerGeneralBlockData> {
  public render(): null | ReactNode | ReactNodeArray {
    return <AdBannerMain iContent={this.props.data} context={this.getContext()} />;
  }
}
